<script>
    import ICAL  from 'ical.js';
    export let url = "";
    
    export let defaultUniform = 'Full Uniform';
    let eventarray = [];

    async function getData() {
        const response = await fetch(`https://api.allorigins.win/raw?url=${encodeURIComponent(`${url}&t=${new Date().getTime()}`)}`);
        const data = await response.text();
        return data;
    }

    function getTime(startDate, endDate) {
        if(startDate.getUTCHours() > 0) {
            const options = {
                timeZone:"Europe/London",
                hour12 : false,
                hour:  "numeric",
                minute: "numeric",
                seconds: false
            };

            return `${startDate.toLocaleTimeString("en-GB",options)} - ${endDate.toLocaleTimeString("en-GB",options)}`;
        }

        return `TBC`;
    }

    function getUniform(description) {
        if(description) {
            if(description.includes('#nouniform')) {
                return "No Uniform";
            }

            if(description.includes('#neckeronly')) {
                return "Necker Only";
            }

            if(description.includes('#fulluniform')) {
                return "Full Uniform";
            }
        }
        return defaultUniform;
    }

    function getClasses(description) {
        let classes = "";
        if(description) {
            if(description.includes('#holidays')) {
                classes += "holidays ";
            }

            if(description.includes('#highlight')) {
                classes += "highlight ";
            }
        }

        return classes;
    }

    function parseEvent(event) {
        var startDate = new Date(event.startDate);
        var endDate = new Date(event.endDate);

        return {
            summary: event.summary,
            times: getTime(startDate, endDate),
            date: `${new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(startDate)} ${startDate.toLocaleDateString().slice(0,-5)}`,
            uniform: getUniform(event.description),
            classes: getClasses(event.description)
        };
    }

    getData().then( data => {
        var jcalData = ICAL.parse(data);
        var comp = new ICAL.Component(jcalData);

        var vevents = comp.getAllSubcomponents();
        var now = new Date();

        vevents.forEach(function(vevent){
            var event = new ICAL.Event(vevent);
            if (event.summary && new Date(event.startDate) > now) {
                eventarray.push(parseEvent(event))
            }
        });

        eventarray = eventarray; //Force redraw
    });
    
</script>

{#each eventarray as event}
<tr class="{event.classes}">
    <td>{event.date}</td>
    <td>{event.summary}</td>
    <td>{event.uniform}</td>
    <td>{event.times}</td>
</tr>
{/each}

<style>
    td {
        border: solid 1px black;
        text-align: center;
    }

    tr.holidays {
        background: #444;
        color: #fff;
        -webkit-print-color-adjust: exact;
    }

    tr.highlight {
        background: #e22e12;
        color: #ffe627;
        -webkit-print-color-adjust: exact;
    }
</style>
